import type { FaireProductEntity } from "../../entity_types/product";

export const p_ndkzt6ctnw: FaireProductEntity = {
  token: "p_ndkzt6ctnw",
  type: "product",
  name: "Extraordinary Zebra Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b319dcc09b4b577b34d2d8ed18f30920d9426547dd238a0a7f844628764aa48f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21599344693d48be8b65cc316e971c132c1086381f989b8e2088d5504c454064.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:55.522Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
